import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import homeSagas from "./Home";
export default function* rootSaga(getState) {
  yield all([homeSagas(), authSagas()]);
}
